import type { FC } from "react"

import { useUpdateGoodsReceipt } from "../../hooks/useUpdateGoodsReceipt"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface PurchaseOrderRemoveConfirmationProps {
  goodsReceipt: GoodsReceipt
  purchaseOrderId: number
  onClose: () => void
  onSuccess: () => void
  successMessage?: string
  customContent?: string
}

export const PurchaseOrderRemoveConfirmation: FC<PurchaseOrderRemoveConfirmationProps> = ({
  goodsReceipt,
  purchaseOrderId,
  onClose,
  onSuccess,
  successMessage,
  customContent,
}) => {
  const { update } = useUpdateGoodsReceipt({
    onSuccess,
    successMessage: successMessage ?? "Purchase Order successfully removed.",
  })

  const handleConfirm = async (): Promise<void> => {
    const updatedOrderIds =
      goodsReceipt.orders?.filter((order) => order.orderId !== purchaseOrderId).map((order) => order.orderId) ?? []

    try {
      await update({
        goodsReceiptId: goodsReceipt.goodsReceiptId,
        orderIds: updatedOrderIds,
        warehouseId: goodsReceipt.warehouseArea?.warehouseAreaId as string,
      })
      onClose()
    } catch {
      onClose()
    }
  }

  return (
    <ConfirmationDialog
      title='Remove Purchase Order'
      content={
        customContent ??
        `Are you sure you want to remove Purchase Order #${purchaseOrderId} from this advanced goods receipt?`
      }
      closeLabel='Cancel'
      confirmLabel='Remove'
      isWarning
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  )
}
